import { Action } from '@ngrx/store';
import { RefNo } from '../../model/ngrx/reference-number.model';
import * as QuoteResultActions from './../actions/quote-result.actions';

export type Actions = QuoteResultActions.Actions;

export function QuoteResultReducer(state: RefNo[] = [], action: QuoteResultActions.Actions) {
    switch (action.type) {
        case QuoteResultActions.ADD_QUOTE_RESULT:
            return [...state, action.payload];
        // Add this case:
        case QuoteResultActions.REMOVE_QUOTE_RESULT:
            state = [];
            return state;
        default:
            return state;
    }
}
